import { ChevronDown, FileText } from "lucide-react";
import { useEffect, useState } from "react";
import { DecisionItem } from "../../lib/commandCore";
import { api, Decision } from "../../lib/tauri";

function dbDecisionToItem(d: Decision): DecisionItem {
  const actionLabels: Record<string, string> = {
    A: "調査",
    B: "案作成",
    C: "実行準備",
    D: "保留",
  };
  const date = new Date(d.createdAt).toLocaleString("ja-JP", {
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
  return {
    id: d.id,
    title: `GO ${d.action} / ${actionLabels[d.action] ?? d.action}`,
    body: d.reason,
    target: date,
  };
}

export function DecisionDrawer({ decisions: fallbackDecisions }: { decisions: DecisionItem[] }) {
  const [open, setOpen] = useState(false);
  const [dbDecisions, setDbDecisions] = useState<DecisionItem[] | null>(null);

  useEffect(() => {
    if (!open) return;
    void api
      .listDecisions?.(20)
      .then((rows) => {
        setDbDecisions(rows.map(dbDecisionToItem));
      })
      .catch((error) => {
        // 失敗時は dbDecisions を null のままフォールバック表示（トーストは出さない）
        console.error("[Flow] listDecisions failed", error);
      });
  }, [open]);

  const displayed = dbDecisions !== null && dbDecisions.length > 0
    ? dbDecisions
    : fallbackDecisions;

  return (
    <section className="command-card">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-3 p-4 text-left"
      >
        <div className="flex items-center gap-3">
          <div className="flex h-9 w-9 items-center justify-center rounded-md bg-hover text-muted dark:bg-zinc-900 dark:text-zinc-200">
            <FileText className="h-4 w-4" />
          </div>
          <div>
            <p className="command-muted text-sm font-semibold">判断ログ</p>
            <h2 className="text-xl font-bold">
              判断理由と記録先
              {dbDecisions !== null && dbDecisions.length > 0 && (
                <span className="ml-2 rounded-full bg-indigo-400/20 px-2 py-0.5 text-sm font-semibold text-indigo-200">
                  {dbDecisions.length}
                </span>
              )}
            </h2>
          </div>
        </div>
        <ChevronDown className={`command-dim h-5 w-5 transition ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="grid gap-2 border-t border-border p-4 dark:border-white/10 md:grid-cols-3">
          {displayed.map((item) => (
            <div key={item.id} className="command-subcard p-3">
              <p className="font-semibold">{item.title}</p>
              <p className="command-muted mt-2 text-sm">{item.body}</p>
              <p className="mt-3 text-xs font-semibold text-brand-700 dark:text-indigo-200">{item.target}</p>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
